"use client";
import RiskBanner from "./risk-banner";
import { ServiceOutageBanner } from "./service-outage-banner";
// import { LocaleMismatchBanner } from "./locale-mismatch-banner";

export function Banners() {
  return (
    <div className="sticky top-[60px] z-[50] flex flex-col" id="global-banners">
      {/* <LocaleMismatchBanner /> */}
      <ServiceOutageBanner />
      <RiskBanner />
    </div>
  );
}
